import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import DescriptionIcon from '@mui/icons-material/Description';
import ArticleIcon from '@mui/icons-material/Article';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

type Variant = 'hero' | 'contact';

interface ResumeDownloadButtonsProps {
  variant?: Variant;
}

const resumeDownloads = [
  { to: '/resume?variant=general&layout=executive', label: 'Executive Resume (1 page)' },
  { to: '/resume?layout=ats', label: 'ATS Resume' },
  { to: '/resume?variant=backend&layout=professional', label: 'Backend Resume' },
  { to: '/resume?variant=ai-automation&layout=professional', label: 'Automation & AI Resume' },
];

function ResumeDownloadButtons({ variant = 'hero' }: ResumeDownloadButtonsProps) {
  const [open, setOpen] = useState(false);

  if (variant === 'contact') {
    return (
      <>
        <Link to="/resume?variant=general&layout=executive" className="ui-card ui-card-lift flex items-center gap-3 p-4 w-full text-left text-ink-secondary hover:text-ink">
          <ArticleIcon />
          <span className="text-sm font-medium">Executive Resume</span>
        </Link>
        <Link to="/resume?layout=ats" className="ui-card ui-card-lift flex items-center gap-3 p-4 w-full text-left text-ink-secondary hover:text-ink">
          <DescriptionIcon />
          <span className="text-sm font-medium">ATS Resume</span>
        </Link>
        <Link to="/cover-letter" className="ui-card ui-card-lift flex items-center gap-3 p-4 w-full text-left text-ink-secondary hover:text-ink">
          <ArticleIcon />
          <span className="text-sm font-medium">Cover Letter Generator</span>
        </Link>
      </>
    );
  }

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="ui-btn-secondary inline-flex items-center gap-1"
        aria-expanded={open}
        aria-haspopup="true"
      >
        <ArticleIcon sx={{ fontSize: 16 }} />
        Download Resume
        <KeyboardArrowDownIcon sx={{ fontSize: 16 }} className={`transition-transform ${open ? 'rotate-180' : ''}`} />
      </button>

      {open && (
        <>
          <button
            type="button"
            className="fixed inset-0 z-40 cursor-default"
            onClick={() => setOpen(false)}
            aria-label="Close menu"
          />
          <div className="absolute left-0 top-full mt-1.5 z-50 min-w-[240px] py-1 rounded-lg border border-line bg-surface shadow-card">
            {resumeDownloads.map((item) => (
              <Link
                key={item.label}
                to={item.to}
                className="block px-3.5 py-2 text-sm text-ink-secondary hover:text-ink hover:bg-canvas-muted transition-colors"
                onClick={() => setOpen(false)}
              >
                {item.label}
              </Link>
            ))}
            <div className="my-1 border-t border-line" />
            <Link
              to="/resume"
              className="block px-3.5 py-2 text-sm font-medium text-accent hover:bg-canvas-muted transition-colors"
              onClick={() => setOpen(false)}
            >
              Resume Generator →
            </Link>
            <Link
              to="/cover-letter"
              className="block px-3.5 py-2 text-sm text-ink-secondary hover:text-ink hover:bg-canvas-muted transition-colors"
              onClick={() => setOpen(false)}
            >
              Cover Letter Generator →
            </Link>
          </div>
        </>
      )}
    </div>
  );
}

export default ResumeDownloadButtons;
